import { z } from 'zod';
import superjson from 'superjson';
import { Selectable } from 'kysely';
import { FilePermissions, SessionParticipants } from '../../helpers/schema';

export const schema = z.object({
  sessionId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

// We extend the participant type to include user details for the UI
export type ParticipantWithUser = Selectable<SessionParticipants> & {
  email: string;
  displayName: string;
  avatarUrl: string | null;
};

export type OutputType = {
  filePermissions: Selectable<FilePermissions>[];
  participants: ParticipantWithUser[];
};

export const getPermissionsList = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ sessionId: input.sessionId });
  const result = await fetch(`/_api/permissions/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
